<template>
  <div class="repertorio-editar">
    <Card
      title="Editando Dados do Arranjo"
      text="Complete o formulário com as informações do arranjo"
      v-if="rptSnap !== undefined && fail === false"
      max-width="1000px"
      class="main-card"
    >
      <div class="infofield">
        <v-text-field label="Nome" filled v-model="rptSnap.nome"/>
        <v-text-field label="Artista" filled v-model="rptSnap.artista"/>
        <v-text-field label="Arranjador" filled v-model="rptSnap.arranjador"/>
        <v-text-field label="Código Identificador" filled disabled v-bind:value="rptSnap.codigo"/>
      </div>
      <div class="infofield">
        <v-text-field label="Link no Google Drive" filled v-model="rptSnap.linkDrive"/>
        <v-checkbox v-model="rptSnap.cantado" label="Este arranjo já foi cantado"/>
        <v-textarea label="Descrição" filled v-model="rptSnap.descricao"></v-textarea>
      </div>
      <div class="infofield">
        Gravações e Mídias<br />
        <div v-for="midia in midias" v-bind:key="midia.key">
          <v-text-field label="Nome" filled v-model="midia.nome"/>
          <v-text-field label="Link" filled v-model="midia.link"/>
        </div>
        <v-btn v-on:click.native="addMidia">Adicionar link de mídia</v-btn>
      </div>
      <div class="filesfield">
        <div class="uploadedfilesfield">
          Arquivos do Arranjo<br />
          <div v-if="!rptSnap.files.length">Não há arquivos associados ao arranjo</div>
          <v-chip v-for="file in rptSnap.files" v-bind:key="file.ref">{{file.filename}}</v-chip>
        </div>
        <v-file-input
          v-model="files"
          color="deep-purple accent-4"
          counter
          label="Upload de arquivos"
          prepend-icon=""
          prepend-inner-icon="mdi-paperclip"
          placeholder="Fazer o upload de áudios e partitura (um de cada vez sorry)"
          filled
          style="margin-top: 10px;"
        >
          <template v-slot:selection="{ index, text }">
            <v-chip
              v-if="index < 2"
              color="deep-purple accent-4"
              dark
              label
              small
            >
              {{ text }}
            </v-chip>

            <span
              v-else-if="index === 2"
              class="overline grey--text text--darken-3 mx-2"
            >
              +{{ files.length - 2 }} File(s)
            </span>
          </template>
        </v-file-input>
      </div>
      <v-divider/>
      <v-btn v-on:click.native="save">Salvar</v-btn>
    </Card>
    <div v-if="repertorio === undefined && fail === true" class="main-card">
        <h1>Erro</h1>
        Não foi possível encontrar esta apresentação
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { db, storageRef, firebaseStorage } from '../main'
import Card from '@/components/Card.vue'

export default {
  name: 'editarrepertorio',
  components: {
    Card
  },
  props: ['repertorioid'],
  watch: {
    dataapr (val) {
      this.dateFormatted = this.formatDate(this.dataapr)
    },
    files () {
      const refpath = 'repertorio/' + this.repertorioid + '/'
      if (this.files) {
        const filename = this.files.name
        let filetype = 'other'
        var uploadTask = null
        if (filename.includes('.pdf')) {
          filetype = 'pdf'
          uploadTask = storageRef.child(refpath + filename).put(this.files)
        } else if (filename.includes('.mp3')) {
          filetype = 'mp3'
          uploadTask = storageRef.child(refpath + filename).put(this.files)
        } else if (filename.includes('.mscz')) {
          filetype = 'mscz'
          uploadTask = storageRef.child(refpath + filename).put(this.files)
        } else {
          alert('Arquivo não suportado')
          this.files = null
          return
        }
        uploadTask.on('state_changed', function (snapshot) {
          // Observe state change events such as progress, pause, and resume
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          console.log('Upload is ' + progress + '% done')
          switch (snapshot.state) {
            case firebaseStorage.TaskState.PAUSED: // or 'paused'
              console.log('Upload is paused')
              break
            case firebaseStorage.TaskState.RUNNING: // or 'running'
              console.log('Upload is running')
              break
          }
        }, function (error) {
          console.log(error)
        }, function () {
          this.files = null
          this.addFile(filetype, refpath + filename, filename)
          // Handle successful uploads on complete
          // For instance, get the download URL: https://firebasestorage.googleapis.com/...
          uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
            console.log('File available at', downloadURL)
          })
        }.bind(this))
      }
    }
  },
  methods: {
    save: function (event) {
      console.log('Salvando')
      const rptSnapMod = this.rptSnap
      console.log(rptSnapMod)
      const rptTrim = {}
      rptSnapMod.midias = this.midias
      rptTrim.arranjador = rptSnapMod.arranjador
      rptTrim.artista = rptSnapMod.artista
      rptTrim.avaliado = rptSnapMod.avaliado
      rptTrim.codigo = rptSnapMod.codigo
      rptTrim.nome = rptSnapMod.nome
      rptTrim.cantado = rptSnapMod.cantado
      db.collection('repertorio')
        .doc(rptSnapMod.codigo)
        .set(rptSnapMod)
        .then(() => {
          console.log('Salvo em coleção repertorio')
        const update = {}
        update['repertorio.' + rptSnapMod.codigo] = rptTrim
          db.collection('indice').doc('indice').update(update).then((a) => {
            if (a) {
              console.log('Erro: ' + a)
            }
            console.log('Update aplicado ao indice')
          })
          this.$router.push({ name: 'Detalhes do Arranjo', params: { repertorioid: rptSnapMod.codigo } })
        })
    },
    addMidia: function () {
      const stub = { nome: '', link: '', key: 0 }
      stub.key = Math.floor(Math.random() * 100000)
      this.midias.push(stub)
      console.log(this.midias)
    },
    addFile: function (filetype, ref, name) {
      const fileentry = { type: filetype, ref: ref, filename: name }
      if (this.rptSnap.files.indexOf(fileentry) === -1) {
        this.rptSnap.files.push(fileentry)
        db.collection('repertorio').doc(this.rptSnap.codigo).update({ files: this.rptSnap.files }).then((a) => {
          if (a) {
            console.log('Erro: ' + a)
          }
          console.log('Update aplicado')
        })
      }
    }
  },
  data () {
    return {
      repertorio: undefined,
      boundquery: [],
      fail: false,
      dbid: String,
      rptSnap: undefined,
      menu1: false,
      files: [],
      midias: []
    }
  },
  mounted () {
    const queryResult = this.$store.state.repertorio.find(x => x.codigo === this.repertorioid)
    this.fail = false
    if (queryResult) {
      console.log('Binding Repertorio from store')
      // this.$unbind('repertorio')
      this.rptSnap = queryResult
      if (this.rptSnap.midias) {
        this.midias = this.rptSnap.midias
      } else {
        this.midias = []
      }
    } else {
      console.log('Binding Repertorio from database')
      this.$bind('boundquery', db.collection('repertorio').where('codigo', '==', this.repertorioid)).then(function () {
        console.log(this.boundquery)
        if (!this.boundquery.length) {
          this.fail = true
        } else {
          this.rptSnap = this.boundquery[0]
          if (this.rptSnap.midias) {
            this.midias = this.rptSnap.midias
          } else {
            this.midias = []
          }
        }
      }.bind(this))
    }

    if (this.rptSnap) {
      this.dbid = this.rptSnap.id
    }
  }
}
</script>

<style scoped>
.main-card {
  margin: auto;
}

h1 {
  font-size: 2rem;
  margin-top: 5px;
  margin-bottom: 0px;
  color: black;
}

.label {
  font-size: 1rem;
  font-style: normal;
  margin-bottom: 0.25em;
}

.organizadorfield {
  font-size: 1.5rem;
}

.title {
  margin-bottom: 20px;
}

.adminoptions {
  background: #CCCCCC;
  margin-top: 20px;
  border-radius: 6px;
  padding: 10px;
}

.ul {
  margin-top: 5px;
}

.inviteoptions {
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.button::v-deep {
  font-size: 1em;
  height: 2em;
  width: fit-content;
  padding-left: 10px;
  padding-right: 10px;
}
.button {
  margin-top: 10px;
}

.filesfield {
  margin-top: 20px;
}

</style>
